import { FeatureProtectedView } from '@moniebook-web/components/molecules/feature-protected-view';
import { OnlineProtectedView, ProtectedView } from '@register-ui/components';
import { FEATURE_FLAGS, PERMISSION_CODES } from '@register-ui/utils';
import { Outlet, type RouteObject } from 'react-router-dom';

const customerRoutes: RouteObject[] = [
    {
        path: '',
        children: [
            {
                path: 'customers',
                element: (
                    <ProtectedView
                        accessList={[PERMISSION_CODES.MANAGE_CUSTOMER]}
                    />
                ),
                children: [
                    {
                        path: '',
                        async lazy() {
                            const CustomerListPage =
                                await import('../features/customers/customers-list');

                            return {
                                Component: CustomerListPage.default,
                            };
                        },
                    },
                    {
                        path: 'create',
                        async lazy() {
                            const CreateCustomerPage =
                                await import('../features/customers/create-customer');

                            return {
                                Component: CreateCustomerPage.default,
                            };
                        },
                    },
                    {
                        path: ':id/edit',
                        async lazy() {
                            const UpdateCustomerPage =
                                await import('../features/customers/update-customer');

                            return {
                                Component: UpdateCustomerPage.default,
                            };
                        },
                    },
                ],
            },
            {
                path: 'terminals',
                element: <Outlet />,
                children: [
                    {
                        path: '',
                        async lazy() {
                            const TerminalsList =
                                await import('../features/terminals/list/terminals');

                            return {
                                Component: TerminalsList.default,
                            };
                        },
                    },
                    {
                        path: 'connect',
                        async lazy() {
                            const TerminalConnect =
                                await import('../features/terminals/connect/connect');

                            return {
                                Component: TerminalConnect.default,
                            };
                        },
                    },
                ],
            },
            {
                path: 'printers',
                element: (
                    <FeatureProtectedView
                        flag={FEATURE_FLAGS.ENABLE_PRINT_AGENT_INTEGRATION}>
                        <Outlet />
                    </FeatureProtectedView>
                ),
                children: [
                    {
                        path: '',
                        async lazy() {
                            const PrintersList =
                                await import('../features/printers/list/printers');

                            return {
                                Component: PrintersList.default,
                            };
                        },
                    },
                    {
                        path: 'add',
                        async lazy() {
                            const AddPrinter =
                                await import('../features/printers/add/add');

                            return {
                                Component: AddPrinter.default,
                            };
                        },
                    },
                    {
                        path: ':id/edit',
                        async lazy() {
                            const UpdatePrinter =
                                await import('../features/printers/update/update');

                            return {
                                Component: UpdatePrinter.default,
                            };
                        },
                    },
                ],
            },
            {
                path: 'transfers',
                element: (
                    <FeatureProtectedView
                        flag={FEATURE_FLAGS.ENABLE_COLLECTION_ACCOUNT}>
                        <OnlineProtectedView>
                            <ProtectedView
                                accessList={[
                                    PERMISSION_CODES.VIEW_COLLECTION_ACCOUNT,
                                ]}
                            />
                        </OnlineProtectedView>
                    </FeatureProtectedView>
                ),
                children: [
                    {
                        path: '',
                        async lazy() {
                            const TransferList =
                                await import('../features/transfers/transfer-list/transfer-list');

                            return {
                                Component: TransferList.default,
                            };
                        },
                    },
                ],
            },
            {
                path: 'reports',
                element: <Outlet />,
                children: [
                    {
                        path: 'summary',
                        async lazy() {
                            const SaleSummary =
                                await import('../features/reports/sales-summary');

                            return { Component: SaleSummary.default };
                        },
                    },
                    {
                        path: 'sales-by-payment-method',
                        async lazy() {
                            const PaymentMethod =
                                await import('../features/reports/sales-by-payment-method');

                            return { Component: PaymentMethod.default };
                        },
                    },
                    {
                        path: 'sales-by-item',
                        async lazy() {
                            const ItemSalesReport =
                                await import('../features/reports/sales-by-item');

                            return { Component: ItemSalesReport.default };
                        },
                    },
                    {
                        path: 'sales-by-category',
                        async lazy() {
                            const SalesByCategory =
                                await import('../features/reports/sales-by-category');

                            return { Component: SalesByCategory.default };
                        },
                    },
                ],
            },
        ],
    },
];

// eslint-disable-next-line import/no-default-export
export default customerRoutes;
